import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, Lock, Zap, Users, Star } from 'lucide-react';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 bg-[var(--red-emphasis)]/15 border border-[var(--red-emphasis)]/30 rounded-lg px-4 py-3 mb-6" data-id="element-56">
      <Zap className="w-4 h-4 text-[var(--red-emphasis)] fill-current flex-shrink-0" data-id="element-57" />
      <span className="text-sm text-[var(--text-primary)]" data-id="element-58">
        Esta oferta expira en:
      </span>
      <div className="flex items-center gap-1 font-mono font-bold text-[var(--red-emphasis)] text-lg" data-id="element-59">
        <span className="bg-[var(--red-emphasis)]/20 px-2 py-0.5 rounded" data-id="element-60">
          {pad(minutes)}
        </span>
        <span className="animate-pulse" data-id="element-61">:</span>
        <span className="bg-[var(--red-emphasis)]/20 px-2 py-0.5 rounded" data-id="element-62">
          {pad(seconds)}
        </span>
      </div>
    </div>;
}
export function CTASection() {
  const bonuses = [{
    label: '📖 Ebook completo: 40 Encuentros',
    value: '$19'
  }, {
    label: '🙏 Guía de oración para cuando no tienes palabras',
    value: '$9'
  }, {
    label: '📋 Tu Plan de Regreso Personal (5 min/día)',
    value: '$9'
  }, {
    label: '✝️ 40 Promesas bíblicas anti-ansiedad',
    value: '$9'
  }];
  return <section id="cta-section" className="py-24 px-6 bg-[var(--bg-deep)] relative overflow-hidden" data-id="element-63">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[var(--accent)] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-64" />

      <div className="max-w-[580px] mx-auto relative z-10" data-id="element-65">
        {/* Scarcity bar */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 bg-[var(--red-emphasis)]/10 border border-[var(--red-emphasis)]/25 rounded-lg px-4 py-2.5 mb-6 text-sm" data-id="element-66">
          <span className="relative flex h-2 w-2" data-id="element-67">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--red-emphasis)] opacity-75" data-id="element-68"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[var(--red-emphasis)]" data-id="element-69"></span>
          </span>
          <span className="text-[var(--red-emphasis)] font-bold" data-id="element-70">
            🔥 Solo quedan 23 copias al precio de lanzamiento
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1e0f13] border border-[var(--accent)]/30 p-8 md:p-10 rounded-xl text-center shadow-[0_0_60px_rgba(0,0,0,0.6)]" data-id="element-71">
          <p className="text-[var(--accent)] uppercase tracking-widest text-xs font-bold mb-3" data-id="element-72">
            Oferta Especial de Lanzamiento
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-[var(--text-heading)] mb-2" data-id="element-73">
            Empieza tu Día 1 hoy
          </h2>
          <p className="text-[var(--text-primary)] mb-8 font-light text-sm" data-id="element-74">
            Porque cuando Dios es lo único que te queda... <br data-id="element-75" />
            <span className="text-[var(--accent)] font-serif italic text-base" data-id="element-76">
              estás a punto de descubrir que lo tienes todo.
            </span>
          </p>

          <CountdownTimer data-id="element-77" />

          {/* Value stack */}
          <div className="bg-[var(--bg-deep)]/60 rounded-lg p-5 mb-6 text-left space-y-3 border border-[var(--bg-elevated)]" data-id="element-78">
            <p className="text-[10px] text-[var(--text-muted)] uppercase tracking-widest mb-3 text-center" data-id="element-79">
              Incluye todo esto:
            </p>
            {bonuses.map((item, i) => <div key={i} className="flex items-center justify-between gap-3 text-sm" data-id="element-80">
                <div className="flex items-center gap-2 text-[var(--text-primary)]" data-id="element-81">
                  <Check className="w-4 h-4 text-[var(--accent)] flex-shrink-0" data-id="element-82" />
                  <span data-id="element-83">{item.label}</span>
                </div>
                <span className="text-[var(--text-muted)] line-through text-xs flex-shrink-0" data-id="element-84">
                  {item.value}
                </span>
              </div>)}
            <div className="border-t border-[var(--bg-elevated)] pt-3 mt-3 flex items-center justify-between" data-id="element-85">
              <span className="text-[var(--text-muted)] text-xs" data-id="element-86">
                Valor total:
              </span>
              <span className="text-[var(--text-muted)] line-through text-sm" data-id="element-87">
                $46 USD
              </span>
            </div>
          </div>

          {/* Price */}
          <div className="flex items-baseline justify-center gap-3 mb-6" data-id="element-88">
            <span className="text-xl text-[var(--text-muted)] line-through opacity-60" data-id="element-89">
              $19 USD
            </span>
            <div className="flex flex-col items-center" data-id="element-90">
              <span className="text-5xl font-serif font-bold text-[var(--accent)]" data-id="element-91">
                $6.39
              </span>
              <span className="text-[var(--text-muted)] text-xs uppercase tracking-widest" data-id="element-92">
                USD — Hoy solamente
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <motion.button onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart', {
              content_name: 'Cuando Dios es lo único que te queda',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
          window.open('https://www.simplementemejor.com/cart/51706800537880:1', '_blank');
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(201,168,76,0)', '0 0 40px 12px rgba(201,168,76,0.4)', '0 0 0 0 rgba(201,168,76,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full py-5 bg-gradient-to-r from-[var(--accent)] to-[#dfc06a] text-[#110608] font-extrabold text-xl rounded-lg shadow-lg overflow-hidden group cursor-pointer mb-4" data-id="element-93">
            <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-94" />
            <span className="relative flex items-center justify-center gap-2" data-id="element-95">
              <Lock className="w-5 h-5" data-id="element-96" />
              🔒 DESCARGAR AHORA POR $6.39
            </span>
          </motion.button>

          {/* Trust badges */}
          <div className="flex items-center justify-center gap-4 text-[10px] text-[var(--text-muted)] mb-6 flex-wrap" data-id="element-97">
            <span className="flex items-center gap-1" data-id="element-98">
              <Lock className="w-3 h-3" data-id="element-99" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-100">|</span>
            <span className="flex items-center gap-1" data-id="element-101">
              <Zap className="w-3 h-3" data-id="element-102" /> Descarga Inmediata
            </span>
            <span className="opacity-30" data-id="element-103">|</span>
            <span className="flex items-center gap-1" data-id="element-104">
              <ShieldCheck className="w-3 h-3" data-id="element-105" /> Garantía 7 días
            </span>
          </div>

          {/* Social proof */}
          <div className="flex items-center justify-center gap-1 mb-6" data-id="element-106">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[var(--accent)] text-[var(--accent)]" data-id="element-107" />)}
            <span className="text-xs text-[var(--text-muted)] ml-2" data-id="element-108">
              4.9/5 · +847 personas ya comenzaron
            </span>
          </div>

          {/* Guarantee */}
          <div className="border border-[var(--accent)]/20 bg-[var(--accent)]/5 rounded-lg p-5" data-id="element-109">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-110">
              <ShieldCheck className="w-5 h-5 text-[var(--accent)]" data-id="element-111" />
              <h4 className="text-[var(--text-heading)] font-serif text-sm font-bold" data-id="element-112">
                Garantía de 7 días
              </h4>
            </div>
            <p className="text-xs text-[var(--text-muted)] leading-relaxed" data-id="element-113">
              Si después de los primeros 7 encuentros no sientes que este
              material fue escrito para ti, escríbeme y te devuelvo cada
              centavo. Sin preguntas incómodas.
            </p>
          </div>

          {/* Book image */}
          <div className="mt-8 flex justify-center" data-id="element-114">
            <img src="https://cdn.magicpatterns.com/uploads/m2Nc5dQ243QcHZ1mxcHfG1/ebook_cover.png" alt="Cuando Dios es lo único que te queda" className="w-28 opacity-90 hover:opacity-100 transition-opacity rounded-md shadow-lg" data-id="element-115" />
          </div>
        </motion.div>
      </div>
    </section>;
}